import { render, staticRenderFns } from "./CozeApiChat.vue?vue&type=template&id=f7219656&scoped=true"
import script from "./CozeApiChat.vue?vue&type=script&lang=js"
export * from "./CozeApiChat.vue?vue&type=script&lang=js"
import style0 from "./CozeApiChat.vue?vue&type=style&index=0&id=f7219656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7219656",
  null
  
)

export default component.exports